import { gql } from '@apollo/client';
import client from 'apollo/apollo-client';

export async function DataPointsState(variables) {
  return await new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: STATE_DATA_POINTS,
        variables,
        skip: skip(variables),
        refetchQueries: ['DataPointsByCustomer', 'DataPointsById'],
        fetchPolicy: 'network-only',
      })
      .then(
        ({
          data: {
            DataPointsStateByCustomer: { error, data, message },
          },
          loading,
        }) => {
          resolve({ data, loading, error, message });
        },
      )
      .catch((error) => {
        reject(new Error({ error: true, message: error.message, data: {} }));
      });
  });
}

function skip(variables) {
  let skip = true;
  let { codeId } = variables;
  skip = ![codeId].every((v) => v);
  return skip;
}

const STATE_DATA_POINTS = gql`
  mutation DataPointsStateByCustomer($codeId: ID!) {
    DataPointsStateByCustomer(codeId: $codeId) {
      error
      data {
        _id
        name
        customerId
        longitude
        latitude
        active
        module
        location
      }
      message
    }
  }
`;
